
class AuthenticationService {
    public static async getAuthenticationToken(): Promise<string | null> {
        const token = process.env.REACT_APP_TOKEN
        return token ? `Bearer ${token}` : null
    }
}

export default AuthenticationService